import { differenceInMinutes, format, formatISO, isValid } from "date-fns";

type DateType = Date | string | number | null | undefined;

export const formatDateTime = (dateObject: DateType, includeSeconds = false) => {
  if (!dateObject) return "-";
  const date = new Date(dateObject);
  if (!isValid(date)) return "-";

  const now = new Date();
  if (date.getFullYear() === now.getFullYear()) {
    return format(date, `MM/dd h:mm${includeSeconds ? ":ss" : ""} a xxx`);
  }
  return format(date, `MM/dd/yy h:mm${includeSeconds ? ":ss" : ""} a xxx`);
};

export const formatTime = (dateObject: DateType, full = false) => {
  if (!dateObject) return "-";
  const date = new Date(dateObject);
  if (!isValid(date)) return "-";

  return full ? formatISO(date) : format(date, "h:mm a xxx");
};

export const formatDate = (dateObject: DateType) => {
  if (!dateObject) return "-";
  const date = new Date(dateObject);
  if (!isValid(date)) return "-";

  const now = new Date();
  if (date.getFullYear() === now.getFullYear()) {
    return format(date, "MM/dd xxx");
  }
  return format(date, "MM/dd/yy xxx");
};

export const getDifferenceInMinutes = (date1: DateType, date2: DateType) => {
  if (!date1 || !date2) return "-";
  return differenceInMinutes(new Date(date1), new Date(date2));
};
